export const environment = {
  production: false,
  apiUrl: 'https://api.staging.first-call.iadn.org/api',
  cookieDomain: '.staging.first-call.iadn.org',
  tokenDomain: '.staging.first-call.iadn.org'
};
